(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dream-d6-scenes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('d6-scene-slider')) {
    customElements.define('d6-scene-slider', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        if (!this.isConnected || this.controller) return;
        this.viewport = this.querySelector('.d6-scenes__viewport');
        this.track = this.querySelector('.d6-scenes__track');
        if (!this.track) return;
        this.slides = Array.from(this.track.children).filter(el => !el.hasAttribute('data-clone'));
        this.count = this.slides.length;
        if (!this.count) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.loop = this.dataset.loop === 'true' && this.count > 1;
        this.offset = this.loop ? this.count : 0;
        this.current = Math.min(this.count - 1, Math.max(0, Number(this.dataset.initial) || 0));
        this.position = this.offset + this.current;
        this.dots = Array.from(this.querySelectorAll('[data-go]'));
        this.status = this.querySelector('[data-status]');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        if (this.loop) {
          const copy = () => {
            const fragment = document.createDocumentFragment();
            this.slides.forEach(slide => {
              const clone = slide.cloneNode(true);
              clone.setAttribute('data-clone', '');
              clone.removeAttribute('data-active');
              clone.setAttribute('aria-hidden', 'true');
              clone.inert = true;
              [clone, ...clone.querySelectorAll('*')].forEach(el => {
                el.removeAttribute('id');
                el.removeAttribute('data-shopify-editor-block');
                el.removeAttribute('data-block-id');
              });
              fragment.append(clone);
            });
            return fragment;
          };
          this.track.prepend(copy());
          this.track.append(copy());
        }
        this.setAttribute('data-ready', '');
        this.toggleAttribute('data-single', this.count === 1);
        this.querySelector('.d6-scenes__controls').hidden = this.count < 2;
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.go(this.position + Number(button.dataset.step), true), {signal}));
        this.dots.forEach(button => button.addEventListener('click', () => {
          const target = Number(button.dataset.go);
          let difference = target - this.current;
          if (this.loop && Math.abs(difference) > this.count / 2) difference -= Math.sign(difference) * this.count;
          this.go(this.position + difference, true);
        }, {signal}));
        this.viewport.addEventListener('keydown', event => {
          if (event.target !== this.viewport) return;
          const keys = {ArrowLeft: -1, ArrowRight: 1};
          if (event.key in keys) {
            event.preventDefault();
            this.go(this.position + keys[event.key], true);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.go(this.offset + (event.key === 'Home' ? 0 : this.count - 1), true);
          }
        }, {signal});
        this.viewport.addEventListener('pointerdown', event => this.startDrag(event), {signal});
        this.viewport.addEventListener('pointermove', event => this.drag(event), {signal});
        this.viewport.addEventListener('pointerup', event => this.endDrag(event), {signal});
        this.viewport.addEventListener('pointercancel', event => this.endDrag(event, true), {signal});
        this.viewport.addEventListener('lostpointercapture', event => this.endDrag(event, true), {signal});
        this.viewport.addEventListener('dragstart', event => event.preventDefault(), {signal});
        this.viewport.addEventListener('click', event => {
          if (performance.now() < (this.suppressClickUntil || 0)) { event.preventDefault(); event.stopPropagation(); }
        }, {signal, capture:true});
        this.track.addEventListener('transitionend', event => {
          if (event.target === this.track && event.propertyName === 'transform') this.settle();
        }, {signal});
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.pointer = null; this.removeAttribute('data-dragging'); this.go(this.offset + index, false); }
        }, {signal});
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => this.measure());
        });
        this.resizeObserver.observe(this.viewport);
        this.measure();
      }
      measure() {
        if (!this.track || !this.isConnected) return;
        this.pointer = null;
        this.removeAttribute('data-dragging');
        const style = getComputedStyle(this);
        const views = Math.max(1, Number(style.getPropertyValue('--d6-views')) || 1);
        this.gap = parseFloat(style.getPropertyValue('--d6-gap')) || 0;
        this.width = this.viewport.clientWidth;
        this.cardWidth = (this.width - (views - 1) * this.gap) / views;
        this.stride = this.cardWidth + this.gap;
        this.position = this.offset + this.current;
        this.paint(false);
        this.update(false);
      }
      paint(animate, drag = 0) {
        clearTimeout(this.settleTimer);
        const x = (this.width - this.cardWidth) / 2 - this.position * this.stride + drag;
        const motion = animate && !this.reduced.matches;
        this.track.style.transition = motion ? 'transform 380ms cubic-bezier(.22,.61,.36,1)' : 'none';
        this.track.style.transform = `translate3d(${x}px,0,0)`;
        this.animating = motion;
        if (motion) this.settleTimer = setTimeout(() => this.settle(), 450);
      }
      go(position, animate) {
        if (this.count < 2) return;
        // Ignore rapid repeated input until the short transition finishes.
        if (this.animating && animate) return;
        this.position = this.loop ? position : Math.max(0, Math.min(this.count - 1, position));
        this.current = ((this.position - this.offset) % this.count + this.count) % this.count;
        this.paint(animate);
        this.update(true);
        if (!this.animating) this.settle();
      }
      settle() {
        clearTimeout(this.settleTimer);
        this.animating = false;
        const normalized = this.offset + this.current;
        if (this.position !== normalized) { this.position = normalized; this.paint(false); }
      }
      update(announce) {
        this.dots.forEach((dot, index) => {
          if (index === this.current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.querySelectorAll('[data-step]').forEach(button => {
          button.disabled = !this.loop && (Number(button.dataset.step) < 0 ? this.current === 0 : this.current === this.count - 1);
        });
        // Originals remain readable; clones never enter the accessibility tree.
        this.slides.forEach((slide, index) => {
          slide.toggleAttribute('data-active', index === this.current);
          slide.querySelectorAll('a, button, input, select, textarea').forEach(el => {
            if (index === this.current) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1');
          });
        });
        if (announce && this.status) this.status.textContent = `${this.current + 1} / ${this.count}`;
      }
      startDrag(event) {
        if (this.count < 2 || this.animating || !event.isPrimary || event.button !== 0 || event.target.closest('a, button, input, textarea, select')) return;
        this.pointer = {id:event.pointerId, x:event.clientX, y:event.clientY, dx:0, axis:null};
        this.viewport.setPointerCapture(event.pointerId);
      }
      drag(event) {
        const p = this.pointer;
        if (!p || p.id !== event.pointerId) return;
        const dx = event.clientX - p.x, dy = event.clientY - p.y;
        if (!p.axis && Math.max(Math.abs(dx), Math.abs(dy)) > 7) p.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (p.axis !== 'x') return;
        p.dx = Math.max(-this.stride, Math.min(this.stride, dx));
        this.setAttribute('data-dragging', '');
        let distance = p.dx;
        if (!this.loop && ((this.current === 0 && distance > 0) || (this.current === this.count - 1 && distance < 0))) distance *= 0.25;
        this.paint(false, distance);
      }
      endDrag(event, cancelled = false) {
        const p = this.pointer;
        if (!p || p.id !== event.pointerId) return;
        this.pointer = null;
        if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
        this.removeAttribute('data-dragging');
        if (p.axis !== 'x') return;
        this.suppressClickUntil = performance.now() + 350;
        const step = !cancelled && Math.abs(p.dx) > Math.min(70, this.cardWidth * 0.15) ? (p.dx < 0 ? 1 : -1) : 0;
        this.go(this.position + step, true);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.resizeFrame);
        clearTimeout(this.settleTimer);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.querySelectorAll('[data-clone]').forEach(el => el.remove());
        if (this.track) { this.track.style.transform = ''; this.track.style.transition = ''; }
        this.querySelectorAll('a[tabindex="-1"]').forEach(el => el.removeAttribute('tabindex'));
        this.controller = null;
        this.pointer = null;
        this.removeAttribute('data-ready');
        this.removeAttribute('data-dragging');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
